var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EEEEEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5182_2043",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H23V23H7V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5182_2043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2551 11.1726C15.6614 10.8514 16.1498 10.6689 16.6786 10.9042C17.0873 11.0864 17.402 11.4804 17.8442 11.5498",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.479 11.8103C16.1821 11.7856 16.7583 12.3825 16.9678 13.055C17.1234 13.554 17.209 14.1037 17.5599 14.4912",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4351 11.0479C14.6885 10.8541 14.9382 10.5685 15.1494 10.2094C15.2063 10.1125 15.2557 10.0185 15.2979 9.92754",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3777 11.0479C11.1243 10.8541 10.8745 10.5685 10.6633 10.2094C10.1105 9.26879 10.2814 8.6041 10.7383 8.20223C11.0293 7.94598 11.3665 7.85848 11.7158 8.07285C11.9295 8.20379 12.1814 8.22316 12.3967 8.09598C12.554 8.00316 12.7261 7.95191 12.9064 7.95191C13.0867 7.95191 13.2586 8.00316 13.4158 8.09598C13.6311 8.22316 13.883 8.20379 14.0971 8.07285C14.4464 7.85848 14.7833 7.94598 15.0745 8.20223C15.2695 8.3741 15.4127 8.59379 15.4692 8.86254",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4553 11.0479C13.5175 10.8866 13.5778 10.6788 13.6306 10.4316C13.6815 10.1929 13.7138 9.97348 13.73 9.77441",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 9.77441C12.0994 9.97348 12.1316 10.1929 12.1826 10.4316C12.2354 10.6788 12.2954 10.8866 12.3579 11.0479",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6455 12.2748C14.6455 12.2748 18.5786 16.9795 18.5786 18.8876C18.5786 18.9317 18.5777 18.9754 18.5761 19.0186",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6697 22.0488H10.1431C9.13 22.0488 7.23438 21.0223 7.23438 18.8873C7.23438 17.9026 8.28187 16.1729 9.29594 14.7295",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1675 12.274C11.1675 12.274 10.6275 12.9199 9.94775 13.8301",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7217 15.167H12.5438C13.0554 15.167 13.4701 15.5816 13.4701 16.0931V16.1171C13.4701 16.649 13.0426 17.0765 12.5153 17.0765H12.0287C11.9047 17.0765 11.8355 17.2198 11.9126 17.3169L13.3435 19.1182",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2278 15.167H14.0912",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7217 16.1221H14.0912",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3152 11.6612C10.3152 11.9999 10.5897 12.2744 10.9284 12.2744H14.8843C15.223 12.2744 15.4976 11.9999 15.4976 11.6612C15.4976 11.3225 15.223 11.048 14.8843 11.048H10.9284C10.5897 11.048 10.3152 11.3225 10.3152 11.6612Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3817 20.5335C14.9632 20.5335 14.624 20.8727 14.624 21.2912C14.624 21.7096 14.9632 22.0488 15.3817 22.0488H19.474C19.8924 22.0488 20.2316 21.7096 20.2316 21.2912C20.2316 20.8727 19.8924 20.5335 19.4739 20.5335",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2296 19.7266C20.2309 19.7428 20.2316 19.7591 20.2316 19.7756C20.2316 20.1941 19.8926 20.5332 19.4738 20.5332H15.3816C14.9631 20.5332 14.624 20.1941 14.624 19.7756C14.624 19.3572 14.9631 19.0178 15.3815 19.0178H19.4737C19.6293 19.0178 19.7737 19.0647 19.8941 19.145",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9811 17.9974L20.6178 17.3682C20.4086 17.0058 19.9452 16.8816 19.5828 17.0908C19.2204 17.3001 19.0963 17.7635 19.3055 18.1258L21.3516 21.6699C21.5609 22.0322 22.0242 22.1564 22.3866 21.9472C22.749 21.738 22.8732 21.2746 22.664 20.9122L21.528 18.9447",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/loan.216424f756b44d694ef1679cabb7c3b4.svg";
export { ForwardRef as ReactComponent };